exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-body {\r\n    width: 250px;\r\n    height: 250px;\r\n    display: block;\r\n    margin: auto;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/UTL/BMI/Admin/Admin-ANG/src/app/layout/modules/admin/programme/programme-details/modals/register-student-modal/register-student-modal.component.css
// module id = ../../../../../src/app/layout/modules/admin/programme/programme-details/modals/register-student-modal/register-student-modal.component.css
// module chunks = main